var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DocumentMenu'),_c('DocumentContent',{attrs:{"type":_vm.type,"device":_vm.device}}),(_vm.isLoading)?_c('DocumentLoading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }